export const RoutesTokens = {
  program: ":idOrName",
  sciArticle: ":sciArticleId",
};

export const AbsolutePages = {
  home: "/",

  login: "/connexion",
  passwordReset: "/reinitialiser-mdp",
  passwordSetup: "/creer-mdp",
  currentUserAccount: "/mon-compte",
  emailValidation: "/confirmer-email",

  search: "/recherche",

  admin: {
    hub: "/admin",
    users: "/admin/utilisateurs",
    newProgram: "/admin/nouveau-programme",
    programDetails: "/admin/programme/" + RoutesTokens.program,
    editProgram: "/admin/modifier-programme/" + RoutesTokens.program,
    editFundraisingSteps: "/admin/modifier-appels-de-fonds/" + RoutesTokens.program,
    updateBlueprints: "/admin/modifier-plans-de-vente/" + RoutesTokens.program,
    sellersControl: "/admin/mandataires",
    pendingValidations: "/admin/validations",
    buyers: "/admin/acheteurs",
    thirdPartyApis: "/admin/apis-tierces",
    pendingNotifications: "/admin/a-notifier",
    fiscalDevices: "/admin/dispositifs",
    updateAppliedFiscalDevices: "/admin/modifier-dispositifs/" + RoutesTokens.program,
    sciArticles: "/admin/statuts",
    newSciArticle: "/admin/statuts/nouveau",
    editSciArticle: "/admin/statuts/" + RoutesTokens.sciArticle,
  },

  seller: {
    hub: "/mandataire",
    programDetails: "/mandataire/programme/" + RoutesTokens.program,
    buyers: "/mandataire/contacts",
    options: "/mandataire/options",
    purchases: "/mandataire/reservations",
    sciArticles: "/mandataire/statuts",
    newSciArticle: "/mandataire/statuts/nouveau",
    editSciArticle: "/mandataire/statuts/" + RoutesTokens.sciArticle,
  },

  resources: {
    root: "/resources",
    housingsCsvModel: "/resources/modèle logements.csv",
  },
};

export const RelativePages = {
  admin: Object.fromEntries(
    Object.entries(AbsolutePages.admin)
      .filter((e) => e[0] !== AbsolutePages.admin.hub)
      .map((e) => {
        e[1] = e[1].substring(AbsolutePages.admin.hub.length);
        return e;
      })
  ),

  seller: Object.fromEntries(
    Object.entries(AbsolutePages.seller)
      .filter((e) => e[0] !== AbsolutePages.seller.hub)
      .map((e) => {
        e[1] = e[1].substring(AbsolutePages.seller.hub.length);
        return e;
      })
  ),

  resources: Object.fromEntries(
    Object.entries(AbsolutePages.resources).map((e) => {
      e[1] = e[1].substring(AbsolutePages.resources.root.length);
      return e;
    })
  ),
};
